
import { PAGE_TYPE } from 'interfaces';
import { PageWrapperProps } from '@/components/wrappers/PageWrapper/query';
import { FooterProps, NavbarProps } from '@/queries/components/blocks';
import {
	SectionCarouselProps,
	SectionCtaProps,
	SectionDemoProps,
	SectionInfiniteCarouselProps, SectionIntroProps,
	SectionSplitWithImageProps,
	SectionWideWithImageProps,
	SectionWithCtaCardProps,
	SectionWithCtaIconCardProps,
	SectionWithExternalContentCardProps,
	SectionWithHubspotPostProps,
	SectionWithIconCardProps, SectionWithIconParagraphProps, SectionWithImageAndCtaCardProps, SectionWithImageStepperProps,
	SectionWithJobPlaceCardProps, SectionWithMissionCardProps, SectionWithRichTextProps, SectionWithSectorProps,
	SectionWithUserCardProps,
	SectionWithVideoStepperProps,
} from '@/queries/components/sections';

interface Parent {
	readonly data?: {
		readonly attributes: {
			readonly pagePath: string;
			readonly parent: Parent;
		},
	}
}

/**
 * Defines the injectable section in a page.
 * Used to have a consistent value accross the app.
 */
export enum INJECTABLE_SECTIONS {
	HUBSPOT_BLOG_POSTS = 'SectionHubspotBlogPost',
	MISSION_CARDS_PREVIEW = 'SectionMissionCards',
	SUMMARY = 'SectionSummary',
}

export interface Page {
	/**
	 * This is the body of the page. It could be any components defined from Strapi.
	 */
	readonly body: (SectionCarouselProps & SectionInfiniteCarouselProps & SectionIntroProps
		& SectionWideWithImageProps & SectionWithCtaCardProps & SectionWithIconCardProps
		& SectionWithSectorProps & SectionWithVideoStepperProps & SectionSplitWithImageProps
		& SectionWithIconParagraphProps & SectionWithImageStepperProps & SectionWithImageAndCtaCardProps
		& SectionWithJobPlaceCardProps & SectionWithHubspotPostProps & SectionWithExternalContentCardProps
		& SectionDemoProps & SectionWithRichTextProps & SectionWithUserCardProps
		& SectionWithMissionCardProps & SectionCtaProps & SectionWithCtaIconCardProps)[];
	/**
	 * Defines if the page should get a summary injected or not.
	 */
	readonly enableSummary: boolean;
	/**
	 * This is the footer of the page.
	 */
	readonly footer: {
		readonly data: {
			readonly attributes: FooterProps;
		};
	};
	/**
	 * This is the Head of the page. Defines all the SEO related data.
	 */
	readonly seo: PageWrapperProps;
	/**
	 * This is the name of the page.
	 */
	readonly name: string;
	/**
	 * This is the navbar of the page.
	 */
	readonly navbar: {
		readonly data: {
			readonly attributes: NavbarProps,
		},
	};
	/**
	 * This is the defined page's path.
	 */
	readonly pagePath: string;
	/**
	 * This is the autogenerated page's full path including it's parent's path.
	 */
	readonly pageFullPath: string;
	/**
	 * This is the page's type, used to define specific parameters.
	 */
	readonly pageType: PAGE_TYPE;
	/**
	 * This is the parent of the page, if it exist. It is a recursion.
	 */
	readonly parent: {
		readonly data?: {
			readonly attributes: {
				readonly pagePath: string;
				readonly parent: Parent;
			},
		},
	};
	readonly createdAt: Date;
	readonly updatedAt?: Date;
	readonly publishedAt?: Date;
}
